module.exports = __webpack_public_path__ + "assets/c0b266b842059203e42a3cc0686165df.mp3";